<template>
	<div>
		<div :style="{backgroundImage: 'url(' + topImage + ')',height: '300px', backgroundPosition: 'center center',backgroundRepeat: 'no-repeat',backgroundSize: 'cover'}">
		</div>	  
			<div style="padding-top: 30px;margin-left: 20%;width: 60%;text-align: center;">
				<div style="display: inline-block;width: 23%;height: 50px;line-height: 50px;background-color: #EBEEF5;">
					{{chineseTitle.label1}}
				</div>
				<div style="display: inline-block;width: 23%;height: 50px;line-height: 50px;background-color: #EBEEF5;margin-left: 1%;margin-right: 0.5%;">
					{{chineseTitle.label2}}
				</div>
				<div style="display: inline-block;width: 23%;height: 50px;line-height: 50px;background-color: #EBEEF5;margin-left: 0.5%;margin-right: 1%;">
					{{chineseTitle.label3}}
				</div>
				<div style="display: inline-block;width: 23%;height: 50px;line-height: 50px;background-color: #EBEEF5;">
					{{chineseTitle.label4}}
				</div>
			</div>
		<div class="label1" style="margin-top: 20px;padding-top:30px;font-size: 40px;padding-bottom:20px;border-bottom:1px solid #EBEEF5;margin-left: 20%;width: 60%;text-align: center;">
			{{chineseTitle.label1}}
		</div>
		
		<div style="padding-top:20px;padding-bottom:50px;margin-left: 20%;width: 60%;line-height: 26px;">
			<div v-html="chineseCompany"></div>
		</div>
		
		
		<div  style="background-color: #f5f8ff;">
			<div class="label2" style="margin-top: 20px;padding-top:30px;font-size: 40px;padding-bottom:20px;border-bottom:1px solid #EBEEF5;margin-left: 20%;width: 60%;text-align: center;">
				{{chineseTitle.label2}}
			</div>
			
			<div style="padding-top:20px;padding-bottom:50px;margin-left: 20%;width: 60%;line-height: 26px;">
				<div v-html="chineseTeam"></div>
			</div>
		</div>
		
		
		<div  class="label3" style="margin-top: 20px;padding-top:30px;font-size: 40px;padding-bottom:20px;border-bottom:1px solid #EBEEF5;margin-left: 20%;width: 60%;text-align: center;">
			{{chineseTitle.label3}}
		</div>
		<div style="padding-top:20px;padding-bottom:50px;margin-left: 20%;width: 60%;line-height: 26px;">
			<div v-html="partnerDetail"></div>
		</div>
		
		
		<div style="background-color: #f5f8ff;padding-bottom: 30px;;">
			<div class="label4" style="margin-top: 20px;padding-top:30px;font-size: 40px;padding-bottom:20px;border-bottom:1px solid #EBEEF5;margin-left: 20%;width: 60%;text-align: center;">
				{{chineseTitle.label4}}
			</div>
			<div style="padding-top:20px;margin-left: 20%;width: 60%;line-height: 26px;">
				<div v-html="honorDetail"></div>
			</div>
			<div style="margin-left: 20%;text-align: left;width: 60%;padding-bottom: 20px;">
				<div  v-for="item in chineseHonor" style="display: inline-block;margin:1.5%;width:22%;height: 340px;vertical-align: top;">
					<div class="messageBox">
						<el-image style="width: 100%; height: 300px;"
						:src="item.url"
						fit="contain">
					<div slot="placeholder" style="text-align:center;padding-top:30%;font-size:12px;color:#909399;">
					  加载中...
					</div></el-image>
						<div style="margin-top: 10px;margin-bottom: 10px;text-align: center;height: 20px;line-height: 20px;">{{item.title}}</div>
					</div>
				</div>
				
			</div>
		</div>
		
<!-- 		<div style="padding-bottom: 30px;;">
			<div style="margin-top: 20px;padding-top:30px;font-size: 40px;padding-bottom:20px;border-bottom:1px solid #EBEEF5;margin-left: 20%;width: 60%;text-align: center;">
				软件著作权
				<div style="text-align: center;margin-top:15px;font-size: 14px;">
					点击查看大图
				</div>
			</div>
			
			<div style="margin-left: 20%;text-align: left;width: 60%;padding-bottom: 20px;white-space: nowrap;overflow: auto;padding-top:20px;">
				<div  v-for="item in softwareCopyright" style="display: inline-block;margin:1%;width:13%;height: auto;vertical-align: top;">
					<div class="messageBox">
						<el-image style="width: 100%; height: auto;"
						:src="item"
						:preview-src-list="[item]"
						fit="contain">
					<div slot="placeholder" style="text-align:center;padding-top:30%;font-size:12px;color:#909399;">
					  加载中...
					</div></el-image>
					</div>
				</div>
				
			</div>
		</div> -->
		
		
	</div>
</template>
<script>
	import utils from '@/utils';
	export default {
		name: 'AboutUs',
		data() {
			return {
				language:"Chinese",
				
				topImage:utils.fileUrl()+'aboutUs/topImage.jpg',
				
				chineseTitle:{
					label1:"公司概况",
					label2:"集团架构",
					label3:"市场与服务",
					label4:"荣誉资质",
				},
				
				chineseCompany:"<div style='margin-bottom: 10px;text-indent:2em;'>贵州全安密灵科技有限公司于2015年4月在贵安新区成立，注册资本6250万元，是国家高新技术及专精特新“小巨人”企业。公司是全国最早涉足电子雷管行业芯片技术研发，并率先实现电子雷管芯片模块产品商业化的企业之一。\n"+
"</div><div style='margin-bottom: 10px;text-indent:2em;'>2012年，公司率先推出完全自主可控的专用电子雷管芯片，相关电子雷管控制模块技术在2015年取得工信部《“雷心工业电子雷管专用电子模块技术”科技成果》鉴定。在此基础上，公司技术水平不断提升并先后与民爆行业内20余家电子雷管生产企业建立合作关系，产品广泛应用于各种爆破场景。</div>\n"+
"<div style='margin-bottom: 10px;text-indent:2em;'>公司拥有工业电子雷管电子控制模块相关专利100余项，包括发明专利20余项、实用新型专利60余项、及芯片布图专利若干项；在电子雷管控制模块技术的研发及应用中处于行业领先地位。</div>\n"+
"<div style='margin-bottom: 10px;text-indent:2em;'>公司愿景：为智慧民爆打造美好未来。</div>",
				
				
				chineseTeam:"<div style='margin-bottom: 10px;text-indent:2em;'>公司团队从业经验近20年，创始团队于2004年与贵州久联民爆器材发展股份有限公司达成合作，双方合作研发的电子雷管芯片技术在2006年通过国家工信部科技成果鉴定为国内首家。目前集团内除一线操作日工外，员工140余人，硕士以上学历30人以上，研发团队均为本科及以上，平均从业经验超过5年，公司骨干不乏长期从事民爆行业的高级管理型人才；清华、复旦等毕业的优秀高校人才；或是华为、德州仪器等顶尖集成电路设计人才。</div>\n" +
							"<div style='margin-bottom: 10px;font-weight:bold;'>全产业链盖5家子公司：从片研发、模块应用研发、模块生产、售后售前服务全覆盖。</div>"+
							
							"<div style='margin-bottom:10px;text-align:center;'><img style='width: 200px; height: auto;' src='"+utils.fileUrl()+"aboutUs/teamLogo1.png' ></img></div>\n" +
							"<div style='margin-bottom: 40px;'><div style='font-weight:bold;display:inline-block;'>贵州固迪科技有限公司：</div>\n" +
							"贵州固迪科技成立于2020年3月，注册资本3000万元，由全安密灵全资持有。主要业务为加工生产全安密灵电子雷管模块，目前为全国规模最大的电子雷管模块生产基地，模块年产能9000万发以上。</div>\n" +
							"<div style='margin-bottom:10px;text-align:center;'><img style='width: 200px; height: auto;' src='"+utils.fileUrl()+"aboutUs/teamLogo2.png' ></img></div>\n" +
							"<div style='margin-bottom: 40px;'><div style='font-weight:bold;display:inline-block;'>广州宏安芯科技有限公司：</div>\n" +
							" 广州宏安芯成立于2021年3月，注册资本2000万元，全安密灵持股51%，广东宏大民爆持股35%，骨干员工持股14%，公司位于广州市增城区，主要业务为生产全安密灵电子雷管模块以及为广东省及周边地区爆破市场提供售后服务工作。公司目前模块年产能6000万发以上。</div>\n" +
							"<div style='margin-bottom:10px;text-align:center;'><img style='width: 200px; height: auto;' src='"+utils.fileUrl()+"aboutUs/teamLogo3.png' ></img></div>\n" +
							"<div style='margin-bottom: 40px;'><div style='font-weight:bold;display:inline-block;'>湖南全红湘芯科技有限公司：</div>\n" +
							"湖南全红湘芯成立于2022年9月，注册资本1000万，全安密灵持股65%，湖南向红化工持股35%。主要业务为加工生产全安密灵电子雷管模块及为湖南省及周边地区爆破市场提供售后服务。公司目前模块年产能6000万发以上。</div>\n" +
							"<div style='margin-bottom:10px;text-align:center;'><img style='width: 200px; height: auto;' src='"+utils.fileUrl()+"aboutUs/teamLogo4.png' ></img></div>\n" +
							"<div style='margin-bottom: 40px;'><div style='font-weight:bold;display:inline-block;'>上海雷芯半导体有限公司：</div>\n" +
							"上海雷芯成立于2021年5月，注册资本1000万元，由全安密灵全资持有。公司位于上海。公司主要业务为研发新一代电子雷管专用芯片及相关芯片技术在其他领域的应用开发。上海雷芯与全安密灵技术中心，共同构成了国内领先的电子雷管芯片研究中心。</div>"+
							
							"<div style='margin-bottom:10px;text-align:center;'><img style='width: 200px; height: auto;' src='"+utils.fileUrl()+"aboutUs/teamLogo5.png' ></img></div>\n" +
							"<div style='margin-bottom: 40px;'><div style='font-weight:bold;display:inline-block;'>全安密灵（杭州）科技有限公司：</div>\n" +
							"杭州全安密灵成立于2023年5月，注册资本2000万。公司主要业务为研发新一代工业电子雷管电子控制模块及其他创新产品提供软硬件技术和数据平台支持。</div>",
											
				partnerDetail:"" +
								"<div style='margin-bottom: 10px;text-indent:2em;'>以贵阳为中心辐射全国，分别设立了东北、华北、西北、华中、华南、西南6大服务基地，提供24小时在线服务、48小时内赶赴现场服务。服务人员经验丰富、保障及时、服务热情、工作有效。</div>\n" +
								"<div style='margin-bottom:10px;text-align:center;'><img style='width: auto; height: 600px;' src='"+utils.fileUrl()+"aboutUs/partnerImage.png' ></img>\n" +
								"<div style='margin-top:10px;text-center;font-weight:bold;'>★地图中五角星标注为服务店（长春、太原、西安、贵阳、广州、岳阳）</div>\n" +
								"</div>",
								
				honorDetail:"<div style='margin-bottom: 10px;text-indent:2em;'>相关专利授权100余项，包括发明专利20余项，实用新型专利60余项，专业芯片布图专利若干项；在电子雷管的研发及应用技术中处于领先地位。</div>\n" +
							"<div style='margin-bottom:20px;text-align:center;'>",
				
				chinesePartner:[
					"https://officemanagementfile.blob.core.windows.net/test/demo%E5%9B%BE%E7%89%871.png",
					"https://officemanagementfile.blob.core.windows.net/test/demo%E5%9B%BE%E7%89%871.png",
					"https://officemanagementfile.blob.core.windows.net/test/demo%E5%9B%BE%E7%89%871.png",
					"https://officemanagementfile.blob.core.windows.net/test/demo%E5%9B%BE%E7%89%871.png",
				],
				
				chineseHonor:[
					{title:"2021年第十届创新创业大赛-优秀企业",url:utils.fileUrl()+'aboutUs/image2.jpg',},
					{title:"第六届创客中国优胜奖",url:utils.fileUrl()+'aboutUs/image4.jpg',},
					{title:"国家级专精特新小巨人企业",url:utils.fileUrl()+'aboutUs/image1.jpg',},
					{title:"2021年贵州制造业企业100强",url:utils.fileUrl()+'aboutUs/image3.jpg',},
					{title:"高新技术企业",url:utils.fileUrl()+'aboutUs/image5.jpg',},
					{title:"贵州省认定企业技术中心",url:utils.fileUrl()+'aboutUs/image6.jpg',},
					{title:"贵州省知识产权优秀企业",url:utils.fileUrl()+'aboutUs/image7.jpg',},
					{title:"省级工业设计中心",url:utils.fileUrl()+'aboutUs/image8.png',},
				],
				
			}
		},
		watch:{
		    '$route'(val, from) {
				console.log(val.query.type)
				var that = this;
				setTimeout(function(){
				   that.type = val.query.type;
				   that.$el.querySelector(".label"+val.query.type).scrollIntoView({ block: "start", behavior: "smooth" });
				}, 300);
		    }
		  },
		methods: {
			
		},
		mounted() {
			if(this.$route.query.type != undefined){
				var that = this;
				setTimeout(function(){
				   that.type = that.$route.query.type;
				   that.$el.querySelector(".label"+that.$route.query.type).scrollIntoView({ block: "start", behavior: "smooth" });
				}, 300);
			}
			
		}

	}
</script>
<style type="text/css">
	.messageBox{
		cursor: pointer;
		transition: all 0.2s;
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.2s;
		/* Opera */
	}
	
	.messageBox:hover{
		margin-top:-15px;
	}
</style>
